module.exports = __webpack_public_path__ + "static/media/small-edit-button.64263678.svg";